module.exports = __webpack_public_path__ + "static/media/matt_icon.1428fab2.png";